import React, { useState } from "react";
import "./Contact_Us.css";
import { Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import "react-phone-input-2/lib/style.css";
import classNames from "classnames";
import Arrow_Btn from "../common_components/common_btn/arrow_btn/Arrow_Btn";
import Location_Animation from "../common_components/location_animation/Location_Animation";
import Fullscreen_Success_Modal from "../common_components/fullscreen_success_modal/Fullscreen_Success_Modal";
import Message_Lottie from "../common_components/animation/message_lottie/Message_Lottie";
import Book_Vehicle from "../common_components/book_vehicle/Book_Vehicle";

const Contact_Us = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const data = [
    {
      icon: faLocationDot,
      label: "Address",
      descn:
        "Gravity Drive, 101,Jay Bhawani Building, oppo crystal honda service center,Uttam nagar, bavdhan, Pin 411021.",
    },
    {
      icon: faEnvelope,
      label: "Email Address",
      descn: "info@gravitydrive.in",
    },
    {
      icon: faPhone,
      label: "Phone Number",
      descn: "+91 8007008833",
    },
  ];

  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.email}</td>
            </tr>            
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
            </tr>
          </table>
        </div>`;

    try {
      const payload = {
        email: "info@gravitydrive.in",
        subject: "Inquiry",
        html: htmlFormat,
        key: "Profcyma",
      };

      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setShowModal(true);
        setTimeout(() => {
          navigate("/");
          setShowModal(false);
        }, 3000);
      } else {
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  return (
    <section className="Contact_Us">
      <div className="container">
        <div className="content_cards_grid">
          {data.map((item, index) => (
            <div key={index} className="content_card">
              <FontAwesomeIcon icon={item.icon} className="content_icon" />
              <h5 className="content_label">{item.label}</h5>
              <p className="content_text">{item.descn}</p>
            </div>
          ))}
        </div>

        <div className="map_form">
          <div className="row">
            <div className="col-lg-5 col-md-6 p-0">
              <div className="map">
                <iframe
                  className="gmap_iframe"
                  frameBorder="0"
                  scrolling="no"
                  marginHeight="0"
                  marginWidth="0"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15133.39075304903!2d73.7810866!3d18.5131838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1719574302642!5m2!1sen!2sin"
                  title="Google Map"
                ></iframe>

                <div className="view_div">
                  <div className="location_div">
                    <Location_Animation />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7 col-md-6 p-0">
              <div className="form">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  {/* Name */}
                  <Form.Group className="input_group">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter you Full name"
                        {...register("name", {
                          required: "Name is required",
                        })}
                        className={classNames("", {
                          "is-valid": getValues("name"),
                        })}
                    />
                     {errors?.name && (
                        <span className="invalid-feedback d-block">
                          {errors.name.message}
                        </span>
                      )}
                  </Form.Group>

                  {/* Email */}
                  <Form.Group className="input_group">
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter you email address"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Invalid email address",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.email,
                        "is-valid": getValues("email"),
                      })}
                    />
                    {errors?.email && (
                      <span className="invalid-feedback d-block">
                        {errors.email.message}
                      </span>
                    )}
                  </Form.Group>

                  {/* Message */}
                  <Form.Group className="input_group">
                    <Form.Control
                      as="textarea"
                      name="message"
                      placeholder="Enter your message"
                      rows={4}
                      {...register("message", {
                        required: "Message is required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.message,
                        "is-valid": getValues("message"),
                      })}
                    />
                    {errors?.message && (
                      <span className="invalid-feedback d-block">
                        {errors.message.message}
                      </span>
                    )}
                  </Form.Group>

                  {/* Submit Button */}
                  <div className="send_btn_div">
                    <Arrow_Btn
                      btnText="Send Message"
                      type="submit"
                      // onClick={() => {
                      //   setShowModal(true);
                      //   setTimeout(() => {
                      //     setShowModal(false);
                      //     navigate("/");
                      //   }, 2500);
                      // }}
                    />
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Fullscreen_Success_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Message_Lottie />}
        message="Message Sent!"
      />

      <Book_Vehicle />
    </section>
  );
};

export default Contact_Us;
